import { Branch } from './branch.model';
import { BranchUser } from './branch-user.model';

export class BranchGroup {
  public BranchGroupIdAsHash: string;
  public BranchGroupID: number;
  public PropositionID?: number;
  public Name: string;
  public Branches: Array<Branch>;
  public BranchUsers: Array<BranchUser>;
}
